import { commentsItems } from '@/mocks/homeData';

export default function CommentsSection() {
  return (
    <section id="comments" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-xs font-medium mb-3">
            真实反馈
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            读者热评
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            来看看大家都在聊什么
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {commentsItems.map((comment, index) => (
            <div
              key={index}
              className="bg-background-100 rounded-xl p-5 md:p-6 flex flex-col"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden flex-shrink-0">
                  <img
                    src={comment.avatar}
                    alt={comment.name}
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="min-w-0">
                  <div className="text-sm font-medium text-foreground-900 truncate">
                    {comment.name}
                  </div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
                <span className="ml-auto px-2 py-0.5 rounded-full bg-primary-50 text-primary-600 text-xs font-medium whitespace-nowrap flex-shrink-0">
                  {comment.tag}
                </span>
              </div>

              <p className="text-sm text-foreground-700 leading-relaxed flex-1 mb-4">
                {comment.content}
              </p>

              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <div className="w-5 h-5 flex items-center justify-center">
                  <i className="ri-thumb-up-line"></i>
                </div>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}